import React, { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';

function LeaderboardTable({ endpoint, title }) {
    const [leaderboard, setLeaderboard] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const myHeaders = new Headers();
                myHeaders.append("Authorization", localStorage.getItem('token'));
                const requestOptions = {
                    method: "GET",
                    headers: myHeaders,
                    redirect: "follow"
                };
                const response = await fetch(`https://beiguru.co.in/api${endpoint}`, requestOptions);
                if (!response.ok) {
                    throw new Error('Failed to fetch leaderboard data');
                }
                const data = await response.json();
                console.log(data.leaderboard);
                setLeaderboard(data.leaderboard);
            } catch (error) {
                console.error('Error fetching leaderboard:', error);
            }
        };

        fetchData();
    }, [endpoint]);

    return (
        <div>
            <h4>{title}</h4>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Rank</th>
                        <th>Name</th>
                        <th>Department</th>
                        <th>Score</th>
                        <th>Avatar</th>
                    </tr>
                </thead>
                <tbody>
                    {leaderboard.map((employee) => (
                        <tr key={employee._id}>
                            <td>{employee.rank}</td>
                            <td>{`${employee.name}`}</td>
                            <td>{employee.department}</td>
                            <td>{employee.score}</td>
                            <td>
                                <img src={employee.avatar.includes('uploads') ? `https://beiguru.co.in/${employee.avatar}` : require(`../assets/a${employee.avatar}.png`)} alt="Avatar" style={{ width: '50px', height: '50px', borderRadius: '50%' }} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
}

export default LeaderboardTable;